import { useQuery } from "@tanstack/react-query";
import { medicalsApi } from "../api/medicalsApi";

export const AI_SCRIBE_USAGE_QUERY_KEY = "ai-scribe-usage";

export interface AiScribeUsageData {
  usedMinutes: number;
  limitMinutes: number | null;
  remainingMinutes: number | null;
  isUnlimited: boolean;
  isOverLimit: boolean;
}

/**
 * Fetches monthly AI Scribe usage for an org.
 * Always fetches when organizationId is set — unlimited plans still return
 * usedMinutes for display (limit/remaining are null).
 *
 * adminSettings / entitlements are accepted for call-site compatibility but
 * do not gate the request; unlimited is determined by the API response.
 */
export const useAiScribeUsage = (
  organizationId?: string,
  _adminSettings?: { tier: string },
  _entitlements?: { tier?: string; addOns?: string[] } | null,
) => {
  return useQuery({
    queryKey: [AI_SCRIBE_USAGE_QUERY_KEY, organizationId],
    queryFn: () => medicalsApi.getAiScribeUsage(organizationId),
    enabled: !!organizationId,
    staleTime: 30_000,
  });
};
